/* AP 6.0 — zone catalogue (collection, univers, hub, recherche). Chargé en defer, sans dépendance.
   - tri : <select data-ap-sort> → recharge avec ?sort_by=
   - « Afficher plus » : [data-ap-more] → Section Rendering API (?section_id=), ajoute les [data-ap-item] ; la pagination reste dans le HTML (SEO)
   - tiroir des sous-collections : [data-ap-open] / [data-ap-drawer] avec recherche [data-ap-filter]
   - texte SEO repliable : [data-ap-clamp]
   - recherche : collections trouvées via /search/suggest.json ([data-ap-search]) */
(function () {
  'use strict';
  /* plusieurs sections de la page incluent ce fichier : une seule exécution */
  if (window.__apCatalog) return;
  window.__apCatalog = 1;
  var doc = document;

  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }

  /* ---------- tri ---------- */
  doc.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-ap-sort]');
    if (!sel) return;
    var u = new URL(location.href);
    u.searchParams.set('sort_by', sel.value);
    u.searchParams.delete('page');
    location.href = u.toString();
  });

  /* ---------- afficher plus ---------- */
  function sectionId(btn) {
    var root = btn.closest('[data-section]');
    if (root) return root.getAttribute('data-section');
    var s = btn.closest('.shopify-section');
    return s ? s.id.replace('shopify-section-', '') : '';
  }
  /* Retour arrière depuis une fiche : les pages ajoutées par « Afficher plus » sont mémorisées (sessionStorage)
     puis rechargées, et la position de défilement est restaurée (sinon le client repart des 24 premiers). */
  var MKEY = 'ap-more:' + location.pathname + location.search;
  function memo() { try { return JSON.parse(sessionStorage.getItem(MKEY)) || null; } catch (e) { return null; } }
  function setMemo(m) { try { sessionStorage.setItem(MKEY, JSON.stringify(m)); } catch (e) {} }
  function loadMore(btn, focus) {
    var url = btn.getAttribute('data-url');
    var sid = sectionId(btn);
    var pager = btn.closest('[data-ap-pager]');
    var grid = pager && pager.parentNode.querySelector('[data-ap-grid]');
    if (!url || !sid || !grid) return Promise.reject(new Error('no grid'));
    btn.setAttribute('aria-busy', 'true');
    var u = new URL(url, location.origin);
    u.searchParams.set('section_id', sid);
    return fetch(u.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html');
        var items = d.querySelectorAll('[data-ap-grid] > [data-ap-item]:not(.ap-lotband)');
        var first = null;
        items.forEach(function (it) { var n = doc.importNode(it, true); if (!first) first = n; grid.appendChild(n); });
        var seen = parseInt(btn.getAttribute('data-seen'), 10) + items.length;
        var total = parseInt(btn.getAttribute('data-total'), 10) || seen;
        btn.setAttribute('data-seen', seen);
        var info = pager.querySelector('[data-ap-info]');
        if (info) info.textContent = btn.getAttribute('data-tpl').replace('__S__', seen);
        var bar = pager.querySelector('[data-ap-bar]');
        if (bar) bar.style.width = Math.min(100, Math.round(seen * 100 / total)) + '%';
        var nb = d.querySelector('[data-ap-more]');
        var nav = d.querySelector('.ap-pages'), cur = pager.querySelector('.ap-pages');
        if (nav && cur) cur.replaceWith(doc.importNode(nav, true));
        if (nb && items.length) { btn.setAttribute('data-url', nb.getAttribute('data-url')); btn.removeAttribute('aria-busy'); }
        else btn.remove();
        if (focus && first) { var a = first.querySelector('a'); if (a) a.focus({ preventScroll: true }); }
        return url;
      });
  }
  doc.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ap-more]');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    var url = btn.getAttribute('data-url');
    loadMore(btn, true).then(function (done) {
      var m = memo() || { urls: [], y: 0 };
      m.urls.push(done); setMemo(m);
    }).catch(function () { if (url) location.href = url; });
  });
  function restoreMore() {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var m = memo();
    if (!nav || nav.type !== 'back_forward') { if (m) sessionStorage.removeItem(MKEY); return; }
    if (!m || !m.urls || !m.urls.length) return;
    var i = 0;
    (function step() {
      var btn = doc.querySelector('[data-ap-more]');
      if (i >= m.urls.length || !btn || btn.getAttribute('data-url') !== m.urls[i]) { window.scrollTo(0, m.y || 0); return; }
      loadMore(btn, false).then(function () { i++; step(); }).catch(function () {});
    })();
  }
  window.addEventListener('pagehide', function () {
    var m = memo(); if (m) { m.y = window.scrollY; setMemo(m); }
  });

  /* ---------- tiroir ---------- */
  var lastOpener = null;
  function openDrawer(id, opener) {
    var dr = doc.getElementById(id);
    if (!dr) return;
    lastOpener = opener;
    dr.hidden = false;
    doc.documentElement.classList.add('ap-lock');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    var f = dr.querySelector('[data-ap-filter]');
    setTimeout(function () { (f || dr.querySelector('[data-ap-close]')).focus(); }, 30);
  }
  function closeDrawer(dr) {
    dr.hidden = true;
    doc.documentElement.classList.remove('ap-lock');
    if (lastOpener) { lastOpener.setAttribute('aria-expanded', 'false'); lastOpener.focus(); }
  }
  doc.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-ap-open]');
    if (o) { openDrawer(o.getAttribute('data-ap-open'), o); return; }
    var c = e.target.closest && e.target.closest('[data-ap-close]');
    if (c) closeDrawer(c.closest('[data-ap-drawer]'));
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var dr = doc.querySelector('[data-ap-drawer]:not([hidden])');
    if (dr) closeDrawer(dr);
  });
  doc.addEventListener('input', function (e) {
    var f = e.target.closest && e.target.closest('[data-ap-filter]');
    if (!f) return;
    var q = norm(f.value.trim()), list = f.closest('[data-ap-drawer]').querySelector('[data-ap-list]'), n = 0;
    list.querySelectorAll('a[data-name]').forEach(function (a) {
      var ok = !q || norm(a.getAttribute('data-name')).indexOf(q) > -1;
      a.hidden = !ok; if (ok) n++;
    });
    var none = list.querySelector('[data-ap-none]');
    if (none) none.hidden = n > 0;
  });

  /* ---------- texte SEO repliable ---------- */
  function initClamp() {
    doc.querySelectorAll('[data-ap-clamp]').forEach(function (root) {
      if (root.__ap) return; root.__ap = 1;
      var body = root.querySelector('[data-ap-clamp-body]'), btn = root.querySelector('[data-ap-clamp-btn]');
      if (!body || !btn) return;
      if (body.scrollHeight <= body.clientHeight + 24) { body.classList.remove('is-clamped'); return; }
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var clamped = body.classList.toggle('is-clamped');
        btn.textContent = btn.getAttribute(clamped ? 'data-more' : 'data-less');
        btn.setAttribute('aria-expanded', clamped ? 'false' : 'true');
      });
    });
  }

  /* ---------- recherche : collections trouvées ---------- */
  function initSearch() {
    var root = doc.querySelector('[data-ap-search]');
    if (!root) return;
    var q = root.getAttribute('data-q'), box = root.querySelector('[data-ap-coll]');
    var tab = root.querySelector('[data-ap-tab-coll]');
    if (!q || !box) { if (tab) tab.hidden = true; return; }
    var url = (root.getAttribute('data-suggest') || '/search/suggest') + '.json?q=' + encodeURIComponent(q) +
      '&resources[type]=collection&resources[limit]=10&resources[options][unavailable_products]=last';
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      var cols = (j && j.resources && j.resources.results && j.resources.results.collections) || [];
      cols = cols.filter(function (c) { return c.handle !== 'tous-nos-posters' && !/option-set/.test(c.handle); });
      var n = root.querySelector('[data-ap-coll-n]');
      if (n) { n.textContent = cols.length; n.hidden = false; }
      if (!cols.length) { if (tab) tab.hidden = true; return; }
      var list = box.querySelector('[data-ap-coll-list]');
      cols.forEach(function (c) {
        var a = doc.createElement('a');
        a.className = 'ap-chip'; a.href = c.url; a.textContent = c.title;
        list.appendChild(a);
      });
      box.hidden = false;
    }).catch(function () {});
    if (tab) tab.addEventListener('click', function () {
      if (box.hidden) return;
      tab.setAttribute('aria-expanded', 'true');
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var a = box.querySelector('a'); if (a) a.focus({ preventScroll: true });
    });
  }

  function init() { initClamp(); initSearch(); restoreMore(); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
})();
